<template>
  <div>
    <h3 v-if="noClipArt">No graphics are allowed on this type of band.</h3>
    <div class="row rbi-graphics" v-if="!noClipArt">
      <div class="col rbi-graphics-area" v-for="(value, areaLabel) in graphicsByArea">

        <div class="card bb-card">
          <div class="card-header"><h5>{{ areaLabel }}</h5></div>
          <div class="card-body area-graphics d-flex justify-content-around flex-wrap">
            <graphic v-for="graphic in value" :key="graphic._path" :graphic="graphic"></graphic>
          </div>
        </div>

        <!--<div class="area-label">-->
          <!--<h6>{{ areaLabel }}</h6>-->
        <!--</div>-->
        <!--<div class="area-graphics">-->
          <!--<graphic v-for="graphic in value" :key="graphic._path" :graphic="graphic"></graphic>-->
        <!--</div>-->
      </div>
    </div>
    <div class="lk-cs-instructions d-none d-sm-block" v-if="!noClipArt && !customband.isPrinted()">
      <div class="mb-2 d-flex align-items-center">
          <h3 class="mb-0">Upload your own artwork <small>(optional)</small></h3>
        <pricing class="ml-4" :tiers="customband.getCustomArtPricingTiers()" btn-text="Pricing" :type="'custom_art'"></pricing>
      </div>
      <p>PLEASE NO PHOTOS OR EMOJIS! To upload, click on an "Add Art" box. Then click the "Upload" tab. We prefer Vector artwork (SVG, AI, PDF, or EPS). Customer service will review artwork for printability and upcharges. To request a proof, add a note to customer service on the last step. We reserve the right to refuse obscene or abusive text or artwork.</p>

    </div>

    <steps-bar></steps-bar>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import groupBy from 'lodash/groupBy'
  import _get from 'lodash/get'

  let stateName = 'bandbuilder.silicone.graphics'

  export default {
    computed: {
      noClipArt () {
        return !this.customband.hasGraphics()
      },
      noPhrase () {
        return !this.customband.hasTexts()
      },
      graphicsByArea () {
        let graphics = this.customband.getGraphics()
        // console.log('graphics', graphics)
        let graphicsByArea = groupBy(graphics, g => { return _get(g, 'areaLabel', '') })
        // console.log('graphicsByArea', graphicsByArea)
        return graphicsByArea
      },
      ...mapState([
        // map this.customband to store.state.customband
        'customband',
        'customstates'
      ])
    },

    created () {
      this.$store.dispatch('customstates/stepIsCompleted', stateName)
      this.$store.dispatch('customband/checkCompletion')
    }
  }
</script>
